import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import classNames from "classnames";
import dayjs from "dayjs";

import { CCard, CCardBody, CCardHeader } from "@coreui/react";

import { nhaCungCapApi } from "src/1/apis/nha_cung_cap.api";
import { useSetQueryData } from "src/1/hooks/query";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { NCCTable, NCCToolbar } from "../../components";

const DanhSachNhaCungCap = () => {
  //#region Data
  const [params, setParams] = useState({
    name: "",
    active: "",
    start_at: dayjs("2008-01-01").toDate(),
    end_at: dayjs().endOf("year").toDate(),
  });

  const { data, isFetching } = useQuery({
    queryKey: ["danh-sach-nha-cung-cap", params],
    queryFn: () => nhaCungCapApi.getAll(params),
    select: (response) =>
      Array.isArray(response) ? response : response?.data?.data,
  });

  const { setQueryData } = useSetQueryData(["danh-sach-nha-cung-cap", params]);

  const isSelectAll = useMemo(() => data?.every((e) => e.check), [data]);

  const selected = useMemo(() => data?.filter((e) => e.check) ?? [], [data]);

  const isMobile = useMobileDevice();
  //#endregion

  //#region Event
  const onSelect = (code, value) => {
    setQueryData(
      data?.map((e) =>
        code === -1 || e.code === code ? { ...e, check: value } : e
      )
    );
  };

  const onSearch = (_params) => setParams(_params);

  const onEdit = () => {
    const id = data.find((e) => e.check)?.id;
  };
  //#endregion

  //#region Render
  return (
    <>
      <CCard className={classNames("toolbar", !isMobile && "sticky")}>
        <CCardBody>
          <NCCToolbar
            params={params}
            // canEdit={selected?.length === 1}
            onEdit={onEdit}
            onSearch={onSearch}
          />
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader></CCardHeader>
        <CCardBody className="px-0 pt-0">
          <NCCTable
            loading={isFetching}
            isSelectAll={isSelectAll}
            data={data}
            onSelect={onSelect}
          />
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
export default DanhSachNhaCungCap;
